import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TenantFacadeService } from '@shared/features/tenant/shared/services/tenant-facade.service';
import { environment } from '@environments/environment';
import { GuardianshipCreateBody } from '../interfaces/guardianship-create-body.interfaces';
import { objectToCamel } from 'ts-case-convert';
import { GuardianshipCreateResponse } from '@app/guardianship/shared/interfaces/guardianship-create-response.interface';
import { map, Observable } from 'rxjs';
import { GuardianshipOverview } from '../interfaces/guardianship-overview.interface';

@Injectable({ providedIn: 'root' })
export class GuardianshipHttpService {
  private readonly _http = inject(HttpClient);
  private readonly _tenantFacadeService = inject(TenantFacadeService);

  public createGuardianship(
    body: GuardianshipCreateBody,
  ): Observable<GuardianshipCreateResponse> {
    const formData = new FormData();
    formData.append('court', body.court.toString());
    if (body.courtOrder) {
      formData.append('court_order', body.courtOrder);
    }

    return this._http
      .post<GuardianshipCreateResponse>(
        `${environment.api}/${this._tenantFacadeService.tenantApiPrefix()}/`,
        formData,
      )
      .pipe(map((response) => objectToCamel(response)));
  }

  public getGuardianship(id: number): Observable<GuardianshipOverview> {
    return this._http
      .get<GuardianshipOverview>(`${environment.api}/guardians/${id}/`)
      .pipe(map((response) => objectToCamel(response)));
  }
}
